import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LanguageSystemXrefEntity} from './language.system.xref.entity';
import {LanguageTermEntity} from './language.term.entity';

@EntityTable('language', '6794be2c-3c19-473d-b374-3315b2278798')
export class LanguageEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.LONG)
    public languageKind: string;

    @Column(FieldTypeKind.GUID)
    public ownerId: string;

    @Transient('language_term', FieldRelationKind.HAS_MANY, 'languageId', 'aliasId', 'aliasId')
    public terms: LanguageTermEntity[];

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;
}
